module.exports = __webpack_public_path__ + "static/img/qris.977367e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qris.png
// module id = fwmH
// module chunks = 1